import { LazyModule } from 'owa-bundling';
import { registerModuleWithPerformanceObserver } from './registerModuleWithPerformanceObserver';

/**
 * This interface extends LazyModule from owa-bundling and overloads the
 * import method to capture performanceEntry associated with the bundle load.
 */
export default class LazyModuleWithPerfData<TModule> extends LazyModule<TModule> {
    constructor(
        private moduleName: string,
        importCallback: () => Promise<TModule>,
        runWhen?: (cb: () => void) => void,
        private runBeforeImport?: () => void
    ) {
        super(importCallback, runWhen);
    }

    public import(): Promise<TModule> {
        this.runBeforeImport?.();
        registerModuleWithPerformanceObserver(this.moduleName);
        return super.import().then(module => module);
    }
}
